(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["garcon-banner"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.gd-banner-videos').forEach(wrap=>{
const videos=Array.from(wrap.querySelectorAll('video'));
const visible=()=>videos.find(v=>getComputedStyle(v).display!=='none')||videos[0];
const start=()=>{const v=visible();if(!v||v.dataset.started)return;v.dataset.started='1';v.muted=true;v.defaultMuted=true;v.setAttribute('preload','auto');let played=false;const go=()=>{if(played)return;played=true;const p=v.play();if(p&&p.catch)p.catch(()=>{});};v.addEventListener('canplaythrough',go,{once:true});v.addEventListener('ended',()=>{const banner=v.closest('[data-video-still]');if(banner)banner.classList.add('is-ended');});v.load();setTimeout(go,4000);};
start();
const mq=matchMedia('(max-width:767px)');if(mq.addEventListener)mq.addEventListener('change',start);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garcon-drop"] && !Shopify.designMode) return;
  try {
    
(()=>{
const reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
const pad=n=>String(n).padStart(2,'0');
const init=root=>{
  if(root.dataset.dropReady)return;
  root.dataset.dropReady='1';
  const track=root.querySelector('[data-drop-track]');
  const slides=Array.from(track.children);
  if(!slides.length)return;
  const videos=slides.map(s=>s.querySelector('video'));
  const prev=root.querySelector('[data-drop-prev]');
  const next=root.querySelector('[data-drop-next]');
  const count=root.querySelector('[data-drop-count]');
  const sound=root.querySelector('[data-drop-sound]');
  let soundOn=false,inView=true,current=-1,timer;
  const index=()=>Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/(track.clientWidth||1))));
  const play=v=>{const p=v.play();if(p&&p.catch)p.catch(()=>{});};
  const sync=()=>{
    const i=index();
    if(prev)prev.disabled=i<=0;
    if(next)next.disabled=i>=slides.length-1;
    if(count)count.textContent=pad(i+1)+' / '+pad(slides.length);
    videos.forEach((v,n)=>{
      if(!v)return;
      if(n===i&&inView){if(current!==i)v.currentTime=0;v.muted=!soundOn;play(v);}
      else{v.pause();}
    });
    current=i;
  };
  const go=d=>track.scrollBy({left:d*track.clientWidth,behavior:reduce?'auto':'smooth'});
  if(prev)prev.addEventListener('click',()=>go(-1));
  if(next)next.addEventListener('click',()=>go(1));
  track.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(sync,90);},{passive:true});
  track.addEventListener('keydown',e=>{
    if(e.key==='ArrowRight'){e.preventDefault();go(1);}
    else if(e.key==='ArrowLeft'){e.preventDefault();go(-1);}
  });
  if(sound)sound.addEventListener('click',()=>{
    soundOn=!soundOn;
    sound.setAttribute('aria-pressed',String(soundOn));
    sound.textContent=soundOn?'Sound: on':'Sound: off';
    const v=videos[index()];
    if(v){v.muted=!soundOn;play(v);}
  });
  if('IntersectionObserver' in window){
    new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;sync();},{threshold:.35}).observe(root);
  }
  sync();
};
const run=()=>document.querySelectorAll('[data-drop-slider]').forEach(init);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
document.addEventListener('shopify:section:load',run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garcon-featured"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('garcon-product-slider')){
customElements.define('garcon-product-slider',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const track=this.querySelector('[data-track]');if(!track)return;
const cards=Array.from(track.querySelectorAll('[data-card]'));
const dots=this.querySelector('[data-dots]');
const buttons=Array.from(this.querySelectorAll('[data-step]'));
const pageLabel=this.dataset.pageLabel||'Page';
const cardWidth=()=>cards[0]?cards[0].getBoundingClientRect().width:track.clientWidth;
const perView=()=>Math.max(1,Math.round(track.clientWidth/cardWidth()));
const pages=()=>Math.max(1,Math.ceil(cards.length/perView()));
const current=()=>Math.min(pages()-1,Math.round(track.scrollLeft/(cardWidth()*perView())));
const goTo=i=>{const p=Math.max(0,Math.min(pages()-1,i));track.scrollTo({left:p*cardWidth()*perView(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
const update=()=>{const i=current(),n=pages();buttons.forEach(b=>b.disabled=Number(b.dataset.step)<0?i===0:i>=n-1);if(dots){if(dots.children.length!==n){dots.replaceChildren();for(let k=0;k<n;k++){const d=document.createElement('button');d.type='button';d.setAttribute('aria-label',pageLabel+' '+(k+1));d.dataset.page=String(k);dots.append(d);}}Array.from(dots.children).forEach((d,k)=>{if(k===i)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current');});dots.style.visibility=n>1?'':'hidden';}buttons.forEach(b=>b.style.visibility=n>1?'':'hidden');};
buttons.forEach(b=>b.addEventListener('click',()=>goTo(current()+Number(b.dataset.step))));
if(dots)dots.addEventListener('click',e=>{const d=e.target.closest('[data-page]');if(d)goTo(Number(d.dataset.page));});
track.addEventListener('keydown',e=>{if(e.target===track&&(e.key==='ArrowRight'||e.key==='ArrowLeft')){e.preventDefault();goTo(current()+(e.key==='ArrowRight'?1:-1));}});
track.addEventListener('scroll',()=>{clearTimeout(this.t);this.t=setTimeout(update,60);},{passive:true});
this.observer=new ResizeObserver(update);this.observer.observe(track);update();
}
disconnectedCallback(){if(this.observer)this.observer.disconnect();this.ready=false;}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garcon-header"]) return;
  try {
    
document.addEventListener('click', event => {
  const link = event.target.closest('[data-language-link]');
  if (!link) return;
  const url = new URL(link.href, location.origin);
  url.search = location.search;
  url.searchParams.delete('locale');
  url.hash = location.hash;
  link.href = url.href;
});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=document.querySelector('.gd-mobile[open]');if(menu){menu.open=false;menu.querySelector('summary').focus()}}});
document.addEventListener('click',event=>{const menu=document.querySelector('.gd-mobile[open]');if(menu&&!menu.contains(event.target))menu.open=false;});
(()=>{
const header=document.querySelector('.gd-header');
if(!header||header.dataset.shopReady)return;
header.dataset.shopReady='1';
const setHeight=()=>document.documentElement.style.setProperty('--gd-header-h',header.offsetHeight+'px');
setHeight();
if(window.ResizeObserver)new ResizeObserver(setHeight).observe(header);else addEventListener('resize',setHeight);
const toggles=Array.from(header.querySelectorAll('[data-panel-toggle]'));
const panels=Array.from(header.querySelectorAll('[data-shop-panel]'));
if(!toggles.length)return;
const panelOf=toggle=>document.getElementById(toggle.dataset.panelToggle);
const toggleOf=panel=>toggles.find(toggle=>panelOf(toggle)===panel);
const isOpen=panel=>panel.classList.contains('is-open');
const closeAll=()=>{panels.forEach(panel=>panel.classList.remove('is-open'));toggles.forEach(toggle=>toggle.setAttribute('aria-expanded','false'));};
const open=(toggle,byKeyboard)=>{closeAll();const panel=panelOf(toggle);if(!panel)return;panel.classList.add('is-open');toggle.setAttribute('aria-expanded','true');if(byKeyboard){const first=panel.querySelector('.gd-shop-list a');if(first)setTimeout(()=>first.focus({preventScroll:true}),50);}};
toggles.forEach(toggle=>toggle.addEventListener('click',event=>{event.stopPropagation();const panel=panelOf(toggle);if(panel&&isOpen(panel))closeAll();else open(toggle,event.detail===0);}));
panels.forEach(panel=>{const closeButton=panel.querySelector('[data-shop-close]');if(closeButton)closeButton.addEventListener('click',()=>{const toggle=toggleOf(panel);closeAll();if(toggle)toggle.focus();});});
document.addEventListener('click',event=>{if(!panels.some(isOpen))return;if(panels.some(panel=>panel.contains(event.target))||toggles.some(toggle=>toggle.contains(event.target)))return;closeAll();});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){const panel=panels.find(isOpen);if(panel){const toggle=toggleOf(panel);closeAll();if(toggle)toggle.focus();}}});
const narrow=matchMedia('(max-width:1050px)');
if(narrow.addEventListener)narrow.addEventListener('change',closeAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garcon-people"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('garcon-people')) {
  customElements.define('garcon-people', class extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.gd-people-stage');
      this.photos = [...this.querySelectorAll('.gd-people-photo')];
      if (!this.photos.length) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mode = this.dataset.mode || 'scattered';
      this.visible = false;
      this.paused = false;
      this.pan = { x: 0, y: 0 };
      this.velocity = { x: 0, y: 0 };
      this.frame = 0;
      this.positions = [];
      this.motionButton = this.querySelector('.gd-people-motion');
      this.motionButton.addEventListener('click', () => {
        this.paused = !this.paused;
        this.startFlow();
      }, { signal });
      this.preload = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        this.preload.disconnect();
      }, { rootMargin: '300px' });
      this.preload.observe(this);
      this.visibility = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        this.startFlow();
      });
      this.visibility.observe(this);
      document.addEventListener('visibilitychange', () => this.startFlow(), { signal });
      this.reduced.addEventListener('change', () => this.startFlow(), { signal });
      this.classList.add('is-ready');
      this.measure();
      this.resize = new ResizeObserver(() => { this.measure(); this.render(); });
      this.resize.observe(this.stage);
      this.stage.addEventListener('pointerdown', e => {
        if (e.button !== 0 || this.pointer) return;
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.velocity = { x: 0, y: 0 };
        this.pointer = { id: e.pointerId, x: e.clientX, y: e.clientY, time: performance.now(), touch: e.pointerType === 'touch' };
        this.stage.setPointerCapture(e.pointerId);
        this.stage.classList.add('is-dragging');
        if (e.pointerType === 'mouse') e.preventDefault();
      }, { signal });
      this.stage.addEventListener('pointermove', e => {
        if (!this.pointer || e.pointerId !== this.pointer.id) return;
        const now = performance.now();
        const dt = Math.max(8, now - this.pointer.time);
        const dx = e.clientX - this.pointer.x;
        const dy = this.mode === 'scattered' && !this.pointer.touch ? e.clientY - this.pointer.y : 0;
        this.pan.x += dx;
        this.pan.y += dy;
        this.velocity = { x: dx / dt * 16.67, y: dy / dt * 16.67 };
        Object.assign(this.pointer, { x: e.clientX, y: e.clientY, time: now });
        this.render();
      }, { signal });
      const finish = e => {
        if (!this.pointer || e.pointerId !== this.pointer.id) return;
        const coast = e.type === 'pointerup' && performance.now() - this.pointer.time < 100;
        this.pointer = null;
        this.stage.classList.remove('is-dragging');
        if (this.stage.hasPointerCapture(e.pointerId)) this.stage.releasePointerCapture(e.pointerId);
        if (!coast || this.reduced.matches) this.velocity = { x: 0, y: 0 };
        this.startFlow();
      };
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => this.stage.addEventListener(type, finish, { signal }));
      this.stage.addEventListener('keydown', e => {
        if (e.code === 'Space') {
          e.preventDefault();
          this.paused = !this.paused;
          this.startFlow();
          return;
        }
        const steps = { ArrowLeft: [160, 0], ArrowRight: [-160, 0], ArrowUp: [0, 120], ArrowDown: [0, -120] };
        if (!steps[e.key] || (this.mode === 'linear' && ['ArrowUp', 'ArrowDown'].includes(e.key))) return;
        e.preventDefault();
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.velocity = { x: 0, y: 0 };
        this.pan.x += steps[e.key][0];
        if (this.width > 600) this.pan.y += steps[e.key][1];
        this.render();
        this.startFlow();
      }, { signal });
      this.querySelectorAll('[data-layout]').forEach(button => button.addEventListener('click', () => {
        if (this.mode === button.dataset.layout) return;
        this.mode = button.dataset.layout;
        this.pan = { x: 0, y: 0 };
        this.velocity = { x: 0, y: 0 };
        this.measure();
        this.startFlow();
      }, { signal }));
      this.addEventListener('shopify:block:select' , e => {
        const index = this.photos.findIndex(photo => photo === e.target || photo.contains(e.target));
        if (index < 0) return;
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.paused = true;
        const point = this.positions[index];
        this.pan.x = (this.width / 2 - point.x - point.w / 2) / point.speed;
        this.pan.y = this.width > 600 && this.mode === 'scattered' ? (this.height / 2 - point.y - point.h / 2) / point.speed : 0;
        this.render();
      }, { signal });
    }
    measure() {
      this.width = this.stage.clientWidth;
      this.height = this.stage.clientHeight;
      const mobile = this.width < 601;
      const unit = mobile ? 165 : Math.min(265, Math.max(195, this.width * .17));
      const sizes = [1.05, .66, .9, .48, 1.15, .73, .52, 1, .6, .87, .45];
      const rowCursors = [12, 78];
      const layers = [[], [], [], []];
      const gap = mobile ? 24 : 40;
      this.worldHeight = this.height * 1.86;
      let linearX = 12;
      const cell = unit * 1.42;
      this.positions = this.photos.map((photo, index) => {
        const ratio = Number(photo.dataset.ratio) || .75;
        const size = sizes[index % sizes.length];
        const depth = size <= .55 ? 0 : size <= .78 ? 1 : size <= 1 ? 2 : 3;
        const speed = [.32, .58, .9, 1.3][depth];
        const h = mobile ? Math.min(158 + depth * 13, 175 / ratio) : Math.min(unit * 1.4 * size, this.height * .84, unit * 1.45 / ratio);
        const w = h * ratio;
        let px, py;
        const row = mobile ? index % 2 : index % 3;
        if (this.mode === 'linear') {
          px = linearX;
          py = (this.height - h) / 2 + [0, 8, -10, 4][index % 4];
          linearX += w + 14;
        } else if (mobile) {
          px = rowCursors[row];
          py = row * 220 + (220 - h) / 2 + [0, 6, -5, 3][index % 4];
          rowCursors[row] += w + 16;
        } else {
          px = Math.floor(index / 3) * cell + [0, cell * .42, cell * .17][row];
          py = row * this.height * .62 + (index % 4) * 17;
        }
        const sameLayer = layers[depth];
        let collision;
        do {
          collision = sameLayer.find(other => {
            const overlapX = px < other.x + other.w + gap && px + w + gap > other.x;
            const overlapY = (mobile || this.mode === 'linear' ? [0] : [-this.worldHeight, 0, this.worldHeight]).some(offset => py < other.y + offset + other.h + gap && py + h + gap > other.y + offset);
            return overlapX && overlapY;
          });
          if (collision) px = collision.x + collision.w + gap;
        } while (collision);
        sameLayer.push({ x: px, y: py, w, h });
        photo.style.width = `${w}px`;
        photo.style.height = `${h}px`;
        photo.style.zIndex = String(depth + 1);
        photo.dataset.depth = String(depth);
        photo.dataset.speed = String(speed);
        photo.style.boxShadow = depth >= 2 ? `0 ${depth * 3}px ${depth * 8}px rgba(39,76,106,${depth === 3 ? .13 : .08})` : 'none';
        return { x: px, y: py, w, h, speed, row, depth };
      });
      this.worldWidth = this.mode === 'linear' ? linearX : Math.ceil(this.photos.length / 3) * cell;
      this.layerWidths = layers.map(layer => Math.max(this.width + 800, ...layer.map(point => point.x + point.w + gap)));
      this.wrapMarginX = Math.max(...this.positions.map(point => point.w)) + 40;
      this.wrapMarginY = Math.max(...this.positions.map(point => point.h)) + 40;
      this.worldWidth = Math.max(this.width + unit * 2, this.worldWidth);
      this.worldHeight = this.height * 1.86;
      this.querySelectorAll('[data-layout]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.layout === this.mode)));
      this.render();
    }

    wrap(value, length, margin) { return ((value + margin) % length + length) % length - margin; }
    render() {
      this.positions.forEach((point, index) => {
        const x = this.wrap(point.x + this.pan.x * point.speed, this.layerWidths[point.depth], this.wrapMarginX);
        const y = this.width < 601 || this.mode === 'linear' ? point.y : this.wrap(point.y + this.pan.y * point.speed, this.worldHeight, this.wrapMarginY);
        this.photos[index].style.transform = `translate3d(${x}px,${y}px,0)`;
      });
    }
    startFlow() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.motionButton.setAttribute('aria-pressed', String(this.paused || this.reduced.matches));
      this.motionButton.querySelector('span').textContent = this.paused || this.reduced.matches ? '▷' : 'Ⅱ';
      if (!this.visible || document.hidden || this.pointer || this.paused || this.reduced.matches) return;
      let last = performance.now();
      const step = now => {
        const dt = Math.min(32, now - last) / 1000;
        last = now;
        this.pan.x += (-18 + this.velocity.x * 60) * dt;
        if (this.width > 600 && this.mode === 'scattered') this.pan.y += (-3 + this.velocity.y * 60) * dt;
        const friction = Math.pow(.93, dt * 60);
        this.velocity.x *= friction;
        this.velocity.y *= friction;
        this.render();
        this.frame = requestAnimationFrame(step);
      };
      this.frame = requestAnimationFrame(step);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resize?.disconnect();
      this.preload?.disconnect();
      this.visibility?.disconnect();
      cancelAnimationFrame(this.frame);
      this.pointer = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garcon-product"]) return;
  try {
    
if(!customElements.get('garcon-product'))customElements.define('garcon-product',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
try{this.prices=JSON.parse(this.querySelector('[data-prices]').textContent);}catch(e){this.prices={};}
this.form=this.querySelector('form');
this.gallery=this.querySelector('[data-gallery]');
this.slides=this.gallery?[...this.gallery.querySelectorAll('.gp-slide')]:[];
this.dots=[...this.querySelectorAll('[data-dot]')];
this.addEventListener('click',e=>{
const dot=e.target.closest('[data-dot]');if(dot)this.goTo(Number(dot.dataset.dot));
const quantity=e.target.closest('[data-quantity]');if(quantity){const input=this.querySelector('[name=quantity]');input.value=Math.max(1,(Number(input.value)||1)+Number(quantity.dataset.quantity));}
const openSize=e.target.closest('[data-open-size]');if(openSize){const tab=this.querySelector('[data-size-tab]');if(tab){tab.open=true;tab.scrollIntoView({behavior:'smooth',block:'nearest'});}}
});
if(this.gallery)this.gallery.addEventListener('scroll',()=>{clearTimeout(this.scrollTimer);this.scrollTimer=setTimeout(()=>this.syncDots(),80);},{passive:true});
this.addEventListener('change',e=>{if(e.target.type==='radio')this.update(true,true);if(e.target.name==='quantity')e.target.value=Math.max(1,Math.floor(Number(e.target.value)||1));});
this.form.addEventListener('submit',e=>{const variant=this.variants.find(v=>String(v.id)===this.form.elements.id.value);if(!variant||!variant.available)e.preventDefault();});
this.update(false,false);
}
goTo(index){const slide=this.slides[index];if(!slide||!this.gallery)return;this.gallery.scrollTo({left:slide.offsetLeft,behavior:'smooth'});}
syncDots(){if(!this.dots.length||!this.gallery)return;const width=this.gallery.clientWidth||1;const index=Math.round(this.gallery.scrollLeft/width);this.dots.forEach((dot,i)=>{if(i===index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});}
showMedia(id){const slide=this.slides.find(el=>el.dataset.media===String(id));if(!slide||!this.gallery)return;const horizontal=this.gallery.scrollWidth>this.gallery.clientWidth+2;if(horizontal)this.gallery.scrollTo({left:slide.offsetLeft,behavior:'smooth'});else slide.scrollIntoView({behavior:'smooth',block:'nearest'});}
selections(){return [...this.querySelectorAll('fieldset[data-option]')].map(f=>{const checked=f.querySelector('input:checked');return checked?checked.value:undefined;});}
update(changeUrl,scroll){
const selections=this.selections();
const variant=selections.length?this.variants.find(v=>v.options.every((value,i)=>value===selections[i])):this.variants[0];
this.form.elements.id.value=variant?variant.id:'';
this.querySelectorAll('[data-purchase]').forEach(b=>b.disabled=!(variant&&variant.available));
const status=this.querySelector('[data-status]');if(status)status.textContent=variant?(variant.available?'':this.dataset.sold):this.dataset.unavailable;
const sku=this.querySelector('[data-sku]');if(sku)sku.textContent=(variant&&variant.sku)||'—';
this.querySelectorAll('fieldset[data-option]').forEach((fieldset,i)=>{
const label=fieldset.querySelector('[data-selected-value]');if(label)label.textContent=selections[i]||'';
fieldset.querySelectorAll('input[type=radio]').forEach(input=>{const ok=this.variants.some(v=>v.available&&v.options[i]===input.value&&v.options.every((value,j)=>j===i||selections[j]===undefined||value===selections[j]));const l=input.nextElementSibling;if(l)l.classList.toggle('gp-value--soldout',!ok);});
});
if(!variant)return;
const price=this.prices[String(variant.id)];
if(price){const current=this.querySelector('[data-price-current]');if(current)current.textContent=price.price;let compare=this.querySelector('[data-price-compare]');if(price.compare){if(!compare){compare=document.createElement('s');compare.setAttribute('data-price-compare','');this.querySelector('[data-price]').append(compare);}compare.textContent=price.compare;}else if(compare)compare.remove();}
const mediaId=variant.featured_media?variant.featured_media.id:null;
if(mediaId&&scroll)this.showMedia(mediaId);
if(changeUrl){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garcon-related"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('garcon-related'))customElements.define('garcon-related',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const url=this.dataset.url;if(!url||this.children.length)return;fetch(url).then(r=>r.ok?r.text():'').then(html=>{if(!html)return;const doc=new DOMParser().parseFromString(html,'text/html');const inner=doc.querySelector('garcon-related');if(inner&&inner.innerHTML.trim())this.innerHTML=inner.innerHTML;}).catch(()=>{});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garcon-store"]) return;
  try {
    
class GdStoreCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.gd-store-track');
    this.slides = Array.from(this.track.children);
    this.total = this.slides.length;
    if (this.total < 2 || this.querySelector('.gd-store-controls')) return;
    var self = this;
    this.index = 0;
    this.userActed = false;
    this.timer = null;
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var controls = document.createElement('div');
    controls.className = 'gd-store-controls';
    this.count = document.createElement('span');
    this.count.className = 'gd-store-count';
    this.count.setAttribute('aria-hidden', 'true');
    var dots = document.createElement('div');
    dots.className = 'gd-store-dots';
    this.dots = this.slides.map(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'gd-store-dot';
      d.setAttribute('aria-label', (i + 1) + ' / ' + self.total);
      d.addEventListener('click', function () { self.go(i); });
      dots.appendChild(d);
      return d;
    });
    var arrows = document.createElement('div');
    arrows.className = 'gd-store-arrows';
    arrows.append(this.arrow(this.dataset.prev, 'M15 5l-7 7 7 7', -1), this.arrow(this.dataset.next, 'M9 5l7 7-7 7', 1));
    controls.append(this.count, dots, arrows);
    this.append(controls);

    var raf = 0;
    this.track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
        if (i !== self.index) { self.index = i; self.render(); }
      });
    }, { passive: true });
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.userActed = true; self.step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); self.userActed = true; self.step(1); }
    });
    this.onResize = function () { self.track.scrollLeft = self.index * self.track.clientWidth; };
    window.addEventListener('resize', this.onResize);

    /* Gentle autoplay: only while on screen, and it stops for good once the visitor interacts. */
    this.addEventListener('pointerdown', function () { self.userActed = true; self.pause(); });
    this.addEventListener('mouseenter', function () { self.pause(); });
    this.addEventListener('mouseleave', function () { self.play(); });
    this.addEventListener('focusin', function () { self.pause(); });
    this.observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { self.play(); } else { self.pause(); }
    }, { threshold: 0.5 });
    this.observer.observe(this);
    this.render();
  }

  disconnectedCallback() {
    this.pause();
    if (this.observer) this.observer.disconnect();
    if (this.onResize) window.removeEventListener('resize', this.onResize);
  }

  arrow(label, path, dir) {
    var self = this;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gd-store-arrow';
    b.setAttribute('aria-label', label || '');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="' + path + '"/></svg>';
    b.addEventListener('click', function () { self.step(dir); });
    return b;
  }

  render() {
    var self = this;
    this.count.textContent = (this.index + 1) + ' / ' + this.total;
    this.dots.forEach(function (d, i) { d.setAttribute('aria-current', i === self.index ? 'true' : 'false'); });
  }

  go(i) {
    this.userActed = true;
    this.goTo(i);
  }

  goTo(i) {
    this.index = i;
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: this.reduce ? 'auto' : 'smooth' });
    this.render();
  }

  step(dir) {
    this.goTo((this.index + dir + this.total) % this.total);
  }

  play() {
    var self = this;
    if (this.timer || this.reduce || this.userActed || this.total < 2) return;
    this.timer = setInterval(function () { if (!document.hidden) self.step(1); }, 5000);
  }

  pause() {
    clearInterval(this.timer);
    this.timer = null;
  }
}
if (!customElements.get('gd-store-carousel')) customElements.define('gd-store-carousel', GdStoreCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garcon-video-journal"]) return;
  try {
    
if (!customElements.get('gd-video-carousel')) {
  customElements.define('gd-video-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.gd-video-track');
      const slides = Array.from(this.querySelectorAll('.gd-video-slide'));
      const selectors = Array.from(this.querySelectorAll('[data-slide]'));
      const previous = this.querySelector('[data-step="-1"]');
      const next = this.querySelector('[data-step="1"]');
      let active = 0;
      const update = () => {
        active = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        slides.forEach((slide, i) => {
          slide.inert = i !== active;
          if (i !== active) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        selectors.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
        previous.disabled = active === 0;
        next.disabled = active === slides.length - 1;
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        const target = button.hasAttribute('data-slide') ? Number(button.dataset.slide) : active + Number(button.dataset.step);
        if (!Number.isFinite(target)) return;
        this.querySelectorAll('video').forEach(video => video.pause());
        track.scrollTo({left: Math.max(0, Math.min(slides.length - 1, target)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
      track.addEventListener('scroll', update, {passive:true});
      this.resizeObserver = new ResizeObserver(() => {
        track.scrollTo({left:active * track.clientWidth,behavior:'instant'});
        update();
      });
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
